import type { Config } from 'tailwindcss';
import { Opacity } from './opacity';
import { Screens } from './screens';
import { BorderRadius } from './border-radius';

export const themeConfigBase: NonNullable<Config['theme']> = {
  screens: Screens,
  extend: {
    containers: Screens,
    borderRadius: BorderRadius,
    opacity: Opacity,
  },
} satisfies NonNullable<Config['theme']>;
